<template>
  <!-- Establece la altura al 100% de la ventana -->
  <div style="height: 50vh">
    <LineChartGenerator
      v-if="chartData"
      :chart-options="computed_chart_options"
      style="height: 100%"
      :chartData="chartData"
      ref="canvas"
    />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs";
import { mapState } from "vuex";
import zoomPlugin from "chartjs-plugin-zoom";
import annotationPlugin from "chartjs-plugin-annotation";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  Legend,
} from "chart.js";

ChartJS.register(
  Legend,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  zoomPlugin,
  annotationPlugin,
  CategoryScale
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    unidades: String,
    chartData: Object,
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  methods: {},

  computed: {
    ...mapState(["maquina"]),
    computed_chart_options() {
      let CurrentChartOptions = this.chartOptions;
      if (this.$route.path == "/fabrication") {
        CurrentChartOptions.scales["y2"] = {
          ticks: {
            stepSize: 50,
          },
          suggestedMin: 400,
          suggestedMax: 1100,
          position: "right",
        };
      }
      return CurrentChartOptions;
    },
  },

  data() {
    const self = this; // Guardamos una referencia al contexto actual (this)

    return {
      chartOptions: {
        responsive: true,
        animation: false, // Desactivar animación
        maintainAspectRatio: false,

        legend: {
          display: false,
          position: "bottom", // Posición de la leyenda (top, bottom, left, right)
          labels: {
            fontColor: "black", // Color del texto de la leyenda
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label =
                this.chartData.datasets[tooltipItem.datasetIndex].label || "";
              if (label) {
                label += ":ssss ";
              }
              label += tooltipItem.yLabel;
              return "label";
            },
          },
        },

        scales: {
          y: {
            ticks: {
              stepSize: 1,
            },
            position: "left",
            suggestedMin: 0,
            suggestedMax: this.$route.path == "/fabrication" ? 40 : 0,
          },
        },
        interaction: {
          mode: "index",
          intersect: false,
        },
        // Dentro del método onHover
        onHover: function (event, chartElement) {
          if (chartElement.length > 0) {
            let miCanvas = self.$refs.canvas.$el.querySelector("canvas");

            const elemento = chartElement[0];
            const mouseX = elemento.element.x;

            // // // // Obteniendo el contexto del canvas
            const ctx = miCanvas.getContext("2d");

            // Dibujar la línea vertical
            ctx.beginPath();
            ctx.moveTo(mouseX, 0);
            ctx.strokeStyle = "#000";
            ctx.lineWidth = 1;
            ctx.lineTo(mouseX, miCanvas.height);
            ctx.stroke();
          }
        },
      },
    };
  },
};
</script>
